export enum HMSWhiteboardUpdateType {
  STARTED = 'STARTED',
  STOPPED = 'STOPPED',
}
